module.exports = __webpack_public_path__ + "img/img-2.92e9c6cb.png";